import styled from 'styled-components';
import { scarpaGray50 } from '@habitech/shared';
import { TableCell } from '../TableCell';

export const Th = styled(TableCell)`
    height: 56px;
    background: ${scarpaGray50};
    font-size: 16px !important;
    margin: auto;
    padding: 8px;
    font-weight: 600;
    text-transform: uppercase;
    @media ${({ theme }) => theme.screenSizes.laptop} {
        font-size: 18px;
    }
`;
